// src/constants/roles.ts
export const ROLES = {
  SUPERADMIN: "Superadmin",
  ADMIN_SALES: "Admin_Sales",
  SALES: "Sales",
  ADMIN: "Admin",
  OPERATOR: "Operator_Gudang",
  SUPERVISOR: "Supervisor_Gudang",  
};
